<template>
   <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
    <div class="container">
      <div class="card" v-if="showIntroduction">
        <div class="card-body">
          <img :src="require('@/assets/loanofficercat.png')" alt="Loan Officer" width="200" height="200">
          <h2 class="card-title">Welcome to Your New Job!</h2>
          <p class="card-text">
            You are Loan Cat, the newest loan officer at Cat Bank. Your job is to evaluate loan applications and decide whether to approve or deny them. Your decisions will impact the bank's success and your career. Good luck!
          </p>
          <button class="btn btn-primary rounded orange" @click="startGame">Start Game</button>
        </div>
      </div>
  
      <div class="card" v-else-if="showLoanApplication">
        <div class="card-body">
          <h2 class="card-title">{{ currentScenario.title }}</h2>
          <p class="card-text">{{ currentScenario.description }}</p>
          <p class="card-text" v-if="customer.name">Customer Name: {{ customer.name }}</p>
          <p class="card-text" v-if="customer.creditScore">Credit Score: {{ customer.creditScore }}</p>
          <p class="card-text" v-if="customer.income">Monthly Income: ${{ customer.income }}</p>
          <p class="card-text">Loan Amount: ${{ currentScenario.loanAmount }}</p>
          <button class="btn btn-success rounded orange mr-2" @click="approveLoan">Approve</button>
          <button class="btn btn-danger rounded black" @click="denyLoan">Deny</button>
          <!-- Conditional rendering for GIFs -->
          <img v-if="approvalStatus === 'approved'" src="@/assets/approved.gif" alt="Approved GIF" width="300" height="200">
          <img v-else-if="approvalStatus === 'denied'" src="@/assets/denied.gif" alt="Denied GIF" width="300" height="200">
        </div>
      </div>
      
      <div v-if="currentScenarioIndex === scenarios.length" class="evaluation-section">
  <h2>Loan Officer Evaluation</h2>
  <p>Final Score: {{ evaluationScore }}%</p>
  <p>{{ evaluationMessage }}</p>
  <ul>
    <li v-for="decision in decisions" :key="decision.scenario">
      {{ decision.scenario }}: {{ decision.decision }} - {{ decision.correct ? 'Correct' : 'Incorrect' }}
      <p>{{ decision.explanation }}</p>
    </li>
  </ul>
  <button @click="restartGame">Play Again</button>
</div>
      </div></div></div></div><br><br><br><br>
  </template>
  
  <script>
  export default {
    data() {
      return {
        showIntroduction: true,
        showLoanApplication: false,
        evaluationScore: 0,
        evaluationMessage: '',
        evaluationExplanations: [],
        currentScenarioIndex: 0,
        passingPercentage: 60,
        scenarios: [
          {
            title: 'Scenario 1: Home Improvement',
            description: 'Customer: Emily Smith\nCredit Score: 720\nMonthly Income: $4500\nLoan Amount: $8000\n\nEmily is a strong applicant with a good credit score and stable income.',
            loanAmount: 8000,
            creditScoreRequirement: 700,
            incomeRequirement: 3000,
          },
          {
            title: 'Scenario 2: New Business Venture',
            description: 'Customer: David Johnson\nCredit Score: 550\nMonthly Income: $3500\nLoan Amount: $10000\n\nDavid\'s credit score is below average, and his income is relatively low.',
            loanAmount: 10000,
            creditScoreRequirement: 600,
            incomeRequirement: 4000,
          },
          {
            title: 'Scenario 3: College Education',
            description: 'Customer: Olivia Williams\nCredit Score: 680\nMonthly Income: $5000\nLoan Amount: $20000\n\nOlivia has a decent credit score and a stable income.',
            loanAmount: 20000,
            creditScoreRequirement: 650,
            incomeRequirement: 4500,
          },
          {
            title: 'Scenario 4: Dream Car Purchase',
            description: 'Customer: Ethan Brown\nCredit Score: 620\nMonthly Income: $6000\nLoan Amount: $15000\n\nEthan has an average credit score and a good income.',
            loanAmount: 15000,
            creditScoreRequirement: 600,
            incomeRequirement: 3000,
          },
          {
            title: 'Scenario 5: Home Loan',
            description: 'Customer: Sophia Garcia\nCredit Score: 760\nMonthly Income: $8000\nLoan Amount: $30000\n\nSophia is a strong candidate with an excellent credit score and high income.',
            loanAmount: 30000,
            creditScoreRequirement: 700,
            incomeRequirement: 5000,
          },
          {
            title: 'Scenario 6: Vacation Loan',
            description: 'Customer: Michael Davis\nCredit Score: 680\nMonthly Income: $5500\nLoan Amount: $5000\n\nMichael wants a loan for a dream vacation.',
            loanAmount: 5000,
            creditScoreRequirement: 650,
            incomeRequirement: 5000,
          },
          {
            title: 'Scenario 7: Small Business Expansion',
            description: 'Customer: Sarah Turner\nCredit Score: 720\nMonthly Income: $6000\nLoan Amount: $15000\n\nSarah is a small business owner looking to expand her business.',
            loanAmount: 15000,
            creditScoreRequirement: 700,
            incomeRequirement: 5500,
          },
          // Add more scenarios as needed...
        ],
        customer: {
          name: '',
          creditScore: 0,
          income: 0,
        },
        totalLoans: 0,
        approvalStatus: null, // Added approvalStatus property
      };
    },
    computed: {
      currentScenario() {
        return this.scenarios[this.currentScenarioIndex];
      },
    },
    methods: {
      startGame() {
        this.showIntroduction = false;
        this.showLoanApplication = true;
      },
      approveLoan() {
        const loanRisk = this.calculateLoanRisk(
          this.customer.creditScore,
          this.customer.income,
          this.currentScenario.creditScoreRequirement,
          this.currentScenario.incomeRequirement
        );
        if (loanRisk >= 0.5) {
          this.totalLoans += this.currentScenario.loanAmount;
          this.evaluationExplanations.push(`Approved: ${this.currentScenario.title}`);
          this.approvalStatus = 'approved'; // Set approvalStatus to 'approved'
        } else {
          this.evaluationExplanations.push(`Denied: ${this.currentScenario.title}`);
          this.approvalStatus = 'denied'; // Set approvalStatus to 'denied'
        }
        this.moveToNextScenario();
      },
      denyLoan() {
        this.evaluationExplanations.push(`Denied: ${this.currentScenario.title}`);
        this.approvalStatus = 'denied'; // Set approvalStatus to 'denied'
        this.moveToNextScenario();
      },
      calculateLoanRisk(creditScore, income, creditScoreRequirement, incomeRequirement) {
        // Calculate loan risk based on credit score and income stability
        const creditRisk = creditScore / 1000;
        const incomeStability = income >= incomeRequirement ? 0.2 : 0.5;
        return creditRisk + incomeStability;
      },
      moveToNextScenario() {
        this.currentScenarioIndex++;
        if (this.currentScenarioIndex < this.scenarios.length) {
          this.showLoanApplication = true;
          this.customer.name = '';
          this.customer.creditScore = 0;
          this.customer.income = 0;
          this.approvalStatus = null; // Reset approvalStatus
        } else {
          this.showLoanApplication = false;
          this.calculateEvaluation();
        }
      },
      calculateEvaluation() {
        // Calculate the evaluation score and message
        this.evaluationScore = Math.round((this.totalLoans / 50000) * 50);
        if (this.evaluationScore >= this.passingPercentage) {
          this.evaluationMessage = 'Congratulations! You passed your probation and became a successful loan officer.';
        } else {
          this.evaluationMessage = 'Unfortunately, you did not meet the bank\'s expectations. Keep practicing to improve your loan evaluation skills.';
        }
      },
      restartGame() {
        // Reset the game
        this.showIntroduction = true;
        this.showLoanApplication = false;
        this.evaluationScore = 0;
        this.evaluationMessage = '';
        this.evaluationExplanations = [];
        this.currentScenarioIndex = 0;
        this.customer.name = '';
        this.customer.creditScore = 0;
        this.customer.income = 0;
        this.totalLoans = 0;
        this.approvalStatus = null;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add your custom CSS here */
  .container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .card {
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .card-body {
    padding: 20px;
  }
  
  .btn {
    cursor: pointer;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    margin-right: 10px;
    transition: background-color 0.3s;
  }
  
  .btn:hover {
    background-color: #555;
  }
  
  .confetti {
    position: relative;
    display: inline-block;
  }
  
  .confetti img {
    width: 50px;
    height: 50px;
    animation: confetti-fall 4s infinite;
  }
  
  @keyframes confetti-fall {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(100vh);
    }
  }

  .wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}
  </style>
  